import { BlockMemberService } from './block-member-service';

export default BlockMemberService;
